var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPodium2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 48,
    viewBox: "0 0 24 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20996 15L2.65996 7.14C2.46376 6.80087 2.37149 6.41159 2.3946 6.02048C2.41771 5.62937 2.55518 5.25366 2.78996 4.94L4.39996 2.8C4.58625 2.55161 4.82782 2.35 5.10553 2.21115C5.38324 2.07229 5.68947 2 5.99996 2H18C18.3104 2 18.6167 2.07229 18.8944 2.21115C19.1721 2.35 19.4137 2.55161 19.6 2.8L21.2 4.94C21.4363 5.25265 21.5755 5.62784 21.6004 6.01897C21.6253 6.4101 21.5347 6.79992 21.34 7.14L16.79 15",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12L5.12012 2.20001",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12L18.88 2.20001",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H16",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C14.7614 22 17 19.7614 17 17C17 14.2386 14.7614 12 12 12C9.23858 12 7 14.2386 7 17C7 19.7614 9.23858 22 12 22Z",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1719 42H8.45703C8.39844 42 8.36914 41.9707 8.36914 41.9121V39.873C8.36914 39.8496 8.38086 39.8262 8.4043 39.8027L12.8516 33.7031C12.9336 33.5918 13.001 33.4512 13.0537 33.2812C13.1123 33.1055 13.1416 32.9531 13.1416 32.8242C13.1416 32.4727 13.0156 32.1504 12.7637 31.8574C12.5117 31.5645 12.1924 31.418 11.8057 31.418C11.4365 31.418 11.123 31.5586 10.8652 31.8398C10.6074 32.1211 10.4785 32.4785 10.4785 32.9121V33.791C10.4785 33.8496 10.4492 33.8789 10.3906 33.8789H8.36914C8.32227 33.8789 8.29883 33.8496 8.29883 33.791V32.9121C8.29883 32.2383 8.46582 31.626 8.7998 31.0752C9.12793 30.5244 9.55859 30.0879 10.0918 29.7656C10.625 29.4375 11.1963 29.2734 11.8057 29.2734C12.4502 29.2734 13.0391 29.4375 13.5723 29.7656C14.0996 30.0996 14.5215 30.5361 14.8379 31.0752C15.1602 31.6143 15.3213 32.1973 15.3213 32.8242C15.3213 33.2168 15.251 33.6182 15.1104 34.0283C14.9756 34.4326 14.7881 34.793 14.5479 35.1094L11.1289 39.8027H15.1719C15.2246 39.8027 15.251 39.8262 15.251 39.873V41.9121C15.251 41.9707 15.2246 42 15.1719 42Z",
    fill: "#00A0DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPodium2);
export default __webpack_public_path__ + "static/media/icon_podium2.9020e781da418001ad265784119b9399.svg";
export { ForwardRef as ReactComponent };